import script from "./IButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./IButton.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./IButton.vue?vue&type=style&index=0&id=a0e64dfe&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__